import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export interface CategoryCardProps {
  title: string;
  icon: React.ReactNode;
  href?: string;
}
export function CategoryCard({
  title,
  icon,
  href = '#'
}: CategoryCardProps) {
  return <a href={href} className="group flex flex-col items-center p-6 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md hover:border-blue-100 transition-all duration-300 text-center" data-id="element-13">
      <div className="w-16 h-16 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center mb-4 group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300" data-id="element-14">
        {icon}
      </div>
      <h3 className="text-gray-900 font-bold text-lg mb-2" data-id="element-15">{title}</h3>
      <div className="flex items-center text-sm font-semibold text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -translate-x-2 group-hover:translate-x-0" data-id="element-16">
        Shop Now <ChevronRightIcon className="w-4 h-4 ml-1" data-id="element-17" />
      </div>
    </a>;
}